import auth0 from 'auth0-js';

const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientID: process.env.REACT_APP_AUTH_CLIENT_ID,
  redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  responseType: 'token id_token',
  scope: 'openid profile'
});

export default webAuth;